import Input from '@returnmates/ui-core/src/components/Input'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

function EmailsSettings() {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Shipped phrase</p>
        <Field name="shippedPhrase">
          {({ input, meta }) => (
            <Input
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Bcc Emails</p>
        <Field name="bccEmails">
          {({ input, meta }) => (
            <Input
              classes={{
                textField: classes.input,
              }}
              placeholder="Enter comma separated bcc emails"
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(EmailsSettings)
